import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { SANCTIONED_STATUS, TONE } from '../../data/constants'
import Chip from '../../components/Chip/Chip'

const SANCTIONED_TONE = {
  [SANCTIONED_STATUS.UNSANCTIONED]: TONE.DANGER,
  [SANCTIONED_STATUS.PENDING]: TONE.WARN,
  [SANCTIONED_STATUS.SANCTIONED]: TONE.OK,
  [SANCTIONED_STATUS.UNKNOWN]: TONE.NEUTRAL,
}
const SANCTIONED_LABEL_ID = {
  [SANCTIONED_STATUS.SANCTIONED]: 'AI_RISK_REPORT.THIRD.SHADOW_AI.SANCTIONED_SANCTIONED',
  [SANCTIONED_STATUS.UNSANCTIONED]: 'AI_RISK_REPORT.THIRD.SHADOW_AI.SANCTIONED_UNSANCTIONED',
  [SANCTIONED_STATUS.PENDING]: 'AI_RISK_REPORT.THIRD.SHADOW_AI.SANCTIONED_PENDING',
  [SANCTIONED_STATUS.UNKNOWN]: 'AI_RISK_REPORT.THIRD.SHADOW_AI.SANCTIONED_UNKNOWN',
}

const getLabelId = (code) => SANCTIONED_LABEL_ID[code] ?? SANCTIONED_LABEL_ID[SANCTIONED_STATUS.UNKNOWN]

export default function ApprovalStatusCell({ row }) {
  const intl = useIntl()
  const status = row.sanctioned
  return <Chip tone={SANCTIONED_TONE[status] ?? TONE.NEUTRAL}>{intl.formatMessage({ id: getLabelId(status) })}</Chip>
}

ApprovalStatusCell.propTypes = {
  row: PropTypes.shape({
    sanctioned: PropTypes.string,
  }).isRequired,
}
